import React from 'react';
import { observer } from 'mobx-react-lite';

const LimitAndPayouts = observer(() => {
  return <>LimitsPayout</>;
});

export default LimitAndPayouts;
